import React from 'react'; // eslint-disable-line no-unused-vars
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import './LessonListItem.scss';
import usePDFdetails from 'utils/hooks/getPDFdetails';
import Animal from 'components/Animal/Animal';

function LessonListItem({
                  isCelebrate = false,
                  // setIsPWallOpen,
                  index,
                  pathname,
                  size,
                  state,
                  isCurrent,
                  title,
                  imgPath,
                  activityNumber,
                  AnimalType,
                  // lockedIfNotSubscribed = false,
                  // hasSeenPaywall = false,
                }){
    const {t} = useTranslation();
    const { pdfUrl, thumbSrc } = usePDFdetails(pathname);
    const history = useHistory();

    const clickOnItem = () => {
      history.push('/theatre/' + pathname);
    }

  const handleKeyActivate = (e) => {
    if (e && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      clickOnItem();
    }
  }

  const handleOnPrint = () => {
    window.open(pdfUrl, '_blank')
  }
    return(
        <>
        <div className={"LessonListItem__main " + (isCelebrate && "enterScaleDown")}>

                <div className={[
                      "LessonListItem__container--list-item ",
                      ("LessonListItem__container_" + size)
                      ].join(" ")}>

                      {isCurrent && !isCelebrate && <div className='ArrowPointer'><img  src="/assets/icons/icon_arrowSelected.svg"/></div>}
                      {/* lock sticker removed */}
                      {state=="completed" &&
                        <div className={"Lesson_Trophy " + (isCelebrate && "jello-vertical")}>
                          <img className={!isCelebrate && "bounceDelayed"} alt={`Lesson complete!`} src={"/assets/icons/icon_trophy-no-shadow.svg"} />
                          <div className="glowCircle "></div>
                        </div>
                      }
                      <div className={["card-container ", (isCurrent && "card-container-current"), (state === 'completed' && "card-container-completed") ].join(" ")} >
                        <div className="card-header" onClick={clickOnItem} role="button" tabIndex={0} onKeyDown={handleKeyActivate}>
                          <div className="card-header_activity-number">{index + 1}</div>
                          <div className="card-header_activity-text">
                            <div className={"LessonListItem__activity-number "}>{t("general." + activityNumber + "_Activity")}</div>
                            <div className={"LessonListItem__title " }>{title}</div>
                          </div>
                        </div>
                        <div className={"lessonImg-container"}>
                          <img onClick={clickOnItem} className={["lessonImg ", (isCurrent && "backgroundGlow")].join(" ")} alt={`catbears language`} src={"/" + imgPath}/>
                          {AnimalType && (
                            <div className={`Lesson_Instructor--component Lesson_Instructor--${AnimalType}`}>
                              <Animal id={AnimalType} className="Lesson_Instructor--animal" alt={AnimalType} />
                            </div>
                          )}
                        </div>
                        {!isCelebrate && <div className={"LessonListItem__footer "}>
                            {(state === 'locked' || state === 'disabled') && (
                                <div onClick={clickOnItem} className={"arcadeBtn arcadeBtn_secondary "}>
                                    {t("general.prepForActivity")}
                                </div>
                            )}
                            {state === 'current' && (
                                <div onClick={clickOnItem} className={"arcadeBtn arcadeBtn-wide arcadeBtn-start"}>
                                    {index > 0 ? t("general.continue") : t("general.start")}
                                </div>
                            )}
                            {state === 'completed' && (
                                <div onClick={clickOnItem} className={"arcadeBtn arcadeBtn-wide"}>{t("general.replay")}</div>
                            )}
                        </div>}
                  </div>
                  {!isCelebrate && thumbSrc && (
                      <div onClick={handleOnPrint} className="activity-pages-link">
                          <img src={thumbSrc} alt="activity page" />
                          <span>{t("general.printActivityPages")}</span>
                      </div>
                  )}
                </div>
        </div>
    </>
    )
}


export default LessonListItem;
